import henrykang from "../Assets/henrykang.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={henrykang}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Henry Kang</h2>
        <br />
        <p className="card-sub-name-style">
          Director, Innovation Capabilities Enablement (ICE), Synapxe
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Henry Kang</h2>
            <h3>Director, Innovation Capabilities Enablement (ICE) Synapxe</h3>

            <br />
            <p>
              Henry is a Director with Synapxe Pte Ltd where he leads the
              Innovation Capabilities Enablement (ICE) department in
              architecting strategic enablers designed to catalyze innovation
              and deliver tangible benefits to public healthcare. With over two
              decades of experience in the public healthtech sector, Henry has
              built a reputation for bridging complex IT strategy with practical
              healthcare delivery. Prior to Synapxe, Henry led IT Planning
              department at the Agency for Integrated Care (AIC), driving
              digital enterprise architecture for the community care sector. His
              professional journey spans across MOH Holdings Pte Ltd, Agency for
              Science, Technology and Research (A*STAR), Infocomm Development
              Authority of Singapore (iDA), and Tan Tock Seng Hospital
              developing his multidisciplinary expertises in IT program
              management, consulting, and data privacy management, as well as
              product and application development. As a catalyst in healthtech
              innovation, Henry holds a particular interest in gerontechnology
              and its potential to transform aged care. He remains dedicated to
              building a future-ready public health system through scalable,
              secure, and impactful technology solutions. Henry holds a Bachelor
              of Computing majoring in system development, a Master of Business
              Administration and a Master in Gerontology.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
